/**
 * A lightweight, extendable front-end developer tool for mobile web page.
 *
 * https://github.com/Tencent/vConsole
 *
 * Keep this disabled until we vendor a pinned copy. The previous
 * `unpkg.com/vconsole@latest` script was incompatible with a stable SRI/CSP setup.
 */
export const VConsole: React.FC = () => null;
